<template>
    <div :class="['loading',loadBg?'bg':'']" v-show="load">
        <div :class="[loadTitle,'loading_warp']">
            <div class="loading-toast">
                <div></div>
                <p>{{loadBg?'图片生成中...':'加载中...'}}</p>
            </div>
        </div>
    </div>
</template>
<script>
// 使用方法   this.$store.commit('loadSkeleton',true)    后面的根据布尔值显示。默认等于false
// 勘察 mapping 方案书 plan 交付报告 report 竣工评价 discuss 项目团队 team
export default {
    name: "loading",
    components: {},
    data() {
        return {};
    },
    computed: {
        loadTitle() {
            // console.log(this.$store.state.loadType);
            return this.$store.state.loadType;
        },
        load() {
            return this.$store.state.loadSklo;
        },
        loadBg() {
            return this.$store.state.loadBg;
        },
    },
    mounted() {},
    methods: {},
};
</script>
<style lang="scss" scoped>
.loading {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: #f5f5f5;
    z-index: 10000;
    // padding: 20px;
    box-sizing: border-box;
    &.bg {
        background-color: rgba(255, 255, 255, 1);
    }
    img {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 200px;
        transform: translate(-50%, -50%);
    }
}
.loading_warp {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}
.home {
    background: #f0f4f1 url("~@/assets/images/loading/home_loading.png")
        no-repeat top/100%;
}
.mapping {
    background: #f0f4f1 url("~@/assets/images/loading/mapping_loading.png")
        no-repeat top/100%;
}
.plan {
    background: #f0f4f1 url("~@/assets/images/loading/plan_loading.png")
        no-repeat top/100%;
}
.report {
    background: #f0f4f1 url("~@/assets/images/loading/team_loading.png")
        no-repeat top/100%;
}
.discuss {
     background: #f0f4f1 url("~@/assets/images/loading/discuss_loading.png")
        no-repeat top/100%;
}
.team{
    background: #f0f4f1 url("~@/assets/images/loading/team_loading.png")
        no-repeat top/100%;
}

.loading-toast {
    width: 3rem !important;
    height: 3rem !important;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 15px;
    overflow: hidden;
    position: relative;
    z-index: 1001;
    div {
        width: 1rem !important;
        height: 1rem !important;
        background: url(../../assets/images/loading.png) no-repeat center/100%
            100%;
        margin: 40px auto 24px;
        animation: loading 1.5s ease-in-out infinite;
    }
    p {
        font-size: 28px;
        text-align: center;
        color: #ffffff;
    }
}
@keyframes loading {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
